import { createI18n } from 'vue-i18n';
import de from './locales/de';
import en from './locales/en';
const savedLanguage = localStorage.getItem('botc-language') || 'de';
export const i18n = createI18n({
    legacy: false,
    locale: savedLanguage,
    fallbackLocale: 'en',
    messages: {
        de,
        en,
    },
});
export function setLanguage(locale) {
    i18n.global.locale.value = locale;
    localStorage.setItem('botc-language', locale);
}
export function getCurrentLanguage() {
    return i18n.global.locale.value;
}
